<case-image
  [path]="image"
  [replacement]="defaultImage"
  [alt]="label"
  className="avatar"
>
</case-image>
<span *ngIf="label" class="ml-2">{{ label }}</span>
